import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import config from './typeConfig';
import styles from './index.less';

export default class Exception extends PureComponent {
    static propTypes = {
        pageType: PropTypes.string,
    };
    render() {
        const { pageType } = this.props;
        return (
            <div className={styles.exception}>
                <div className={styles.imgBlock}>
                    <div
                        className={styles.imgEle}
                        style={{
                            backgroundImage: `url(${config[pageType].img})`,
                        }}
                    />
                </div>
                <div className={styles.content}>
                    <h1>{config[pageType].title}</h1>
                    <div className={styles.desc}>{config[pageType].desc}</div>
                </div>
            </div>
        );
    }
}

Exception.defaultProps = {
    pageType: '404',
};
